import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router/index";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import InstantSearch from "vue-instantsearch";
import filter from "./utils/filters";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Notifications from 'vue-notification'
// rich editor for vuetify
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import InfiniteLoading from 'vue-infinite-loading';
import VueHotkey from 'v-hotkey'
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;

Vue.use(VueHotkey)
Vue.use(InfiniteLoading, { /* options */ });
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi'
})

Vue.use(Notifications);
Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);
Vue.use(filter);

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
